import React from 'react';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import {
  getDeviceValuesByPageId,
  getMetricsTablePlatformsCascaderOptions,
  getPlatformCascaderOptions,
} from '@/pages/intelligence/pages/TopCharts/PCGames/_config/utils';
import { getDeviceOptionByType } from '@intelligence/pages/TopCharts/PCGames/_config/utils';
import { TopchartPageId } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { FilterTimeType } from '@intelligence/utils/filterUtils';
import {
  getSourceMetricsByValue,
  getMetricOptionByValue,
  DEFAULTSELECTSHOWRTLIST,
} from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/KPITrends/components/MetricsSelection/config';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import { useIntl } from 'umi';
import TipContext from '@home/components/TipContextComponents/TipContext';
import { getOptionText } from '@intelligence/components/Form/components/common/Cascader';
import { IShortcutItem } from '@intelligence/components/Form/type';
import useConfigureTexts from '@intelligence/hooks/useConfigureTexts';
import { createPlatformCascaderDisplayRenderConfig } from '@intelligence/_config/components/filters/platformCascaderDisplayRender';

const entityType = 'combine';

/** 对比页指标筛选器不展示的指标 */
const COMPARE_EXCLUDE_METRIC_VALUES = ['alinea__ps_price', 'alinea__xbox_price'];

const platformCascaderDefaultValue = {
  mscience: [
    'Full Game',
    'DLC: All Other',
    'DLC: Expansion',
    'DLC: Content Pre-Purchase Pass',
    'DLC: Unlockable Content Pass',
    'Subscription',
  ],
  gsd: ['Full Game', 'In-Game Currency'],
};
const comparePlatformCascaderOptions =
  getMetricsTablePlatformsCascaderOptions(
    {},
    createPlatformCascaderDisplayRenderConfig({ width: 320 }),
  );

const platformCascaderDefaultValueNull = Object.fromEntries(
  (comparePlatformCascaderOptions.children || []).map((source: any) => [
    source.value,
    [],
  ]),
);

// 筛选器value默认值
export const DEFAULTFILTERVALUE = {
  [filterKeyMap.ALL_Games]: {
    value: [],
    keywords: '',
    isSearchAll: true,
    checkedList: [],
  },
  [filterKeyMap.RANGE_TIME]: {
    type: 'month',
    value: ['', ''],
  },
  [filterKeyMap.RANGE_RELEASE_TIME]: {
    type: 'month',
    value: ['1', '6'],
  },
  [filterKeyMap.METRIC_SELECT_FOR_KPI_TREND]: {
    value: {
      type: 'monthly',
      types: 'all',
      metrics: DEFAULTSELECTSHOWRTLIST,
      sources: ['all'],
      source_metrics: getSourceMetricsByValue(DEFAULTSELECTSHOWRTLIST),
      metricsOptions: getMetricOptionByValue(DEFAULTSELECTSHOWRTLIST),
      selectedMetricsValue: 'metrics',
      shotSelectValue: 'all',
      selectCutVal: 'hot',
    },
  },
  [filterKeyMap.REGION]: {
    regions: ['global'],
    markets: ['global'],
    type: 'market',
  },
  [filterKeyMap.METRICTABLE_DEVICE]: {
    value: getDeviceValuesByPageId(TopchartPageId.PCConsoleMetricsTable),
  },
  [filterKeyMap.DIGITAL_SEGMENT_MULTIPLE]: {
    value: ['All'],
  },
  [filterKeyMap.ALIGN_TO_RELEASE]: {
    value: false,
  },
  [filterKeyMap.CASCADER]: {
    value: platformCascaderDefaultValue,
  },
  [filterKeyMap.PLATFORMCASCADER]: {
    value: platformCascaderDefaultValueNull,
  },
};

// 筛选器自定义布局列表
export const FILTERKEYLIST = [
  filterKeyMap.ROW,
  filterKeyMap.ALL_Games,
  filterKeyMap.ALIGN_TO_RELEASE,
  filterKeyMap.RANGE_RELEASE_TIME,
  filterKeyMap.RANGE_TIME,
  filterKeyMap.TIPICON,
  filterKeyMap.ROW,
  filterKeyMap.METRIC_SELECT_FOR_KPI_TREND,
  filterKeyMap.ROW,
  filterKeyMap.REGION,
  filterKeyMap.PLATFORMCASCADER,
  // filterKeyMap.DIGITAL_SEGMENT_MULTIPLE,
  filterKeyMap.CASCADER,
];

// 筛选器list配置
export const DEFAULTINPUTLIST = [
  {
    savePopupVisble: 0,
    key: filterKeyMap.ROW,
  },
  {
    savePopupVisble: 1,
    key: filterKeyMap.ALL_Games,
    default: '',
    isBlueButton: true,
    params: { entity_type: entityType, game_type: 'current_game' },
    chooseUpNum: 20,
    hasShortCut: true,
    notSelectTips: 'dbi_compare_pcconsole_game_selection_empty',
    leftTitleKey: 'dbi_compare_add_game_to_compare',
  },
  {
    savePopupVisble: 1,
    key: filterKeyMap.ALIGN_TO_RELEASE,
  },
  {
    savePopupVisble: 1,
    key: filterKeyMap.RANGE_RELEASE_TIME,
    showSelectType: false,
    showShortcut: FilterTimeType.commonRange,
    rangeTimeOtherStyle: true,
    visibleinlist: 1,
  },
  {
    savePopupVisble: 1,
    type: filterKeyMap.RANGE_TIME,
    key: filterKeyMap.RANGE_TIME,
    showSelectType: false,
    showShortcut: FilterTimeType.commonRange,
    rangeTimeOtherStyle: true,
    isShowAlloftime: false,
    visibleinlist: 2,
  },
  {
    savePopupVisble: 0,
    key: filterKeyMap.TIPICON,
    content: 'dbi_compare_pcconsole_game_filter_time_tips',
  },
  {
    savePopupVisble: 0,
    key: filterKeyMap.ROW,
  },
  // 销量 metric_selection_for_trends
  {
    savePopupVisble: 1,
    key: filterKeyMap.METRIC_SELECT_FOR_KPI_TREND,
    overlayClassName: 'dbi-metric-select-auto-scroll-overlay',
    isShowSourceTips: false,
    isSelectShortCut: true,
    hasDatabrainData: true,
    excludeMetricValues: COMPARE_EXCLUDE_METRIC_VALUES,
    entityType,
  },
  {
    savePopupVisble: 0,
    key: filterKeyMap.ROW,
  },
  // 区域全球
  {
    savePopupVisble: 1,
    key: filterKeyMap.REGION,
    default: [],
    visible: 1,
    disableNoChina: true,
    entityType,
  },
  // 产品分类
  {
    savePopupVisble: 1,
    key: filterKeyMap.CASCADER,
    type: 'cascader',
    options: getPlatformCascaderOptions(
      { [filterKeyMap.CASCADER]: platformCascaderDefaultValue },
      {
        customInputDisplayRender: (prop: any) => {
          const {
            isOne,
            isSingleGroupChecked,
            isGroupFullChecked,
            isShortcutGroupChecked,
            shortcutCheckedGroup,
            checkedGroup,
            isMetricChecked,
            showNum,
            showItem,
            DisplayEmpty,
            shortcutOptions,
          } = prop;
          const MAP: any = {};
          let shortcutCheckedLength: any = 0;
          shortcutCheckedGroup &&
            shortcutCheckedGroup.map((groupItem: any, index: number) => {
              shortcutCheckedLength += Object.values(groupItem.includes).flat(
                Infinity,
              ).length;
            });
          const { formatMessage } = useIntl();
          const { configureTexts } = useConfigureTexts();
          const displayShortcutLabel = shortcutOptions.map(
            (item: IShortcutItem, index: number) => {
              const trueLabel = item.labelKey
                ? formatMessage({ id: item.labelKey })
                : item.label;
              return index !== shortcutOptions.length - 1
                ? `${trueLabel}, `
                : trueLabel;
            },
          );
          return (
            <>
              <div className="dbi-cascader-select-button dbi-select-button">
                <span className="select-button-text">
                  {formatMessage({ id: 'Segment For Sales' })}
                </span>
                <div style={{ marginRight: 6, lineHeight: 0 }}>
                  <TipContext
                    Performance="left"
                    tipText={configureTexts?.segment_for_sales_select_tips}
                  />
                  {/* //  AWidth={AWidth} */}
                </div>
                {(isOne && (
                  <>
                    <div className="dbi-cascader-select-button-flex">
                      <img
                        className="dbi-cascader-common-icon"
                        src={getDataSourceIcon(showItem.parent.icon)}
                      />
                      <span>
                        {showItem.parent?.labelKey
                          ? formatMessage({ id: showItem.parent.labelKey })
                          : showItem.parent?.label}
                        -
                        {showItem.labelKey
                          ? formatMessage({ id: showItem.labelKey })
                          : showItem.label}
                      </span>
                    </div>
                  </>
                )) ||
                  (isShortcutGroupChecked && (
                    // <>
                    //   <div className="dbi-cascader-select-button-flex">
                    //     <span>{shortcutCheckedLabels}</span>
                    //   </div>
                    // </>
                    <>
                      <div className="dbi-cascader-select-button-flex">
                        <span>
                          {showItem.length > 0 &&
                          showItem.length === shortcutCheckedLength
                            ? shortcutCheckedGroup &&
                              shortcutCheckedGroup.map(
                                (item: any, i: number) => (
                                  <span key={item.value}>
                                    <img
                                      className="dbi-cascader-common-icon"
                                      src={getDataSourceIcon(MAP[item?.label])}
                                    />
                                    {getOptionText(item)}
                                    {i < shortcutCheckedGroup.length - 1
                                      ? ','
                                      : ''}
                                    &nbsp;&nbsp;
                                  </span>
                                ),
                              )
                            : showItem.length}
                        </span>
                      </div>
                    </>
                  )) ||
                  (isSingleGroupChecked && (
                    <>
                      <div className="dbi-cascader-select-button-flex">
                        <img
                          className="dbi-cascader-common-icon"
                          src={getDataSourceIcon(showItem?.icon)}
                        />
                        <span>
                          {showItem?.labelKey
                            ? formatMessage({ id: showItem?.labelKey })
                            : showItem?.label}
                        </span>
                      </div>
                    </>
                  )) ||
                  (isGroupFullChecked && (
                    <span>{formatMessage({ id: 'All' })}</span>
                  )) ||
                  (isMetricChecked && (
                    <div className="dbi-cascader-select-button-txt">
                      {showNum}
                    </div>
                  )) || <DisplayEmpty />}
              </div>
            </>
          );
        },
        customSearchItemDisplayRender: (prop: any) => {
          const {
            selectedItem,
            formatMessage,
            showLabelFormatFn: getShowLabel,
            tagAutoWidth,
            tagWidth,
            displayParentText,
          } = prop;
          return (
            <span style={{ maxWidth: tagAutoWidth ? 'unset' : tagWidth }}>
              <img
                className="dbi-cascader-common-icon"
                style={{ verticalAlign: 'middle' }}
                src={getDataSourceIcon(selectedItem.parent?.icon)}
              />
              {displayParentText
                ? `${getShowLabel(
                    selectedItem.parent || {},
                    formatMessage,
                  )} - ${getShowLabel(selectedItem, formatMessage)}`
                : getShowLabel(selectedItem, formatMessage)}
            </span>
          );
        },
        isUseClose: true,
        isNoShortcutClear: true,
        width: 400,
      },
    ),
    visible: 1,
    visibleinlist: 1,
  },
  // {
  //   savePopupVisble: 1,
  //   key: filterKeyMap.DIGITAL_SEGMENT_MULTIPLE,
  //   default: DEFAULTFILTERVALUE[filterKeyMap.DIGITAL_SEGMENT_MULTIPLE],
  // },
  {
    savePopupVisble: 1,
    key: filterKeyMap.METRICTABLE_DEVICE,
    type: filterKeyMap.CONSOLE_DEVICE,
    options: getDeviceOptionByType(TopchartPageId.PCConsoleMetricsTable),
    showIcon: true,
    btnName: 'dbi_platform',
    visible: 2,
    default: getDeviceValuesByPageId(TopchartPageId.PCConsoleMetricsTable),
    AWidth: 356,
    tips: 'dbi_compare_pcconsole_game_filter_platform_tips',
  },
  {
    savePopupVisble: 1,
    key: filterKeyMap.PLATFORMCASCADER,
    options: comparePlatformCascaderOptions,
    type: 'cascader',
    visible: 1,
    visibleinlist: 1,
  },
];
